var React = require('react');

function BasketInline (props) {
    return React.createElement("g",props,React.createElement("g",null,[React.createElement("polygon",{"points":"0 0 24 0 24 24 0 24","key":0}),React.createElement("path",{"className":"color","fill":"#ffffff","d":"M7,18 C5.9,18 5.01,18.9 5.01,20 C5.01,21.1 5.9,22 7,22 C8.1,22 9,21.1 9,20 C9,18.9 8.1,18 7,18 Z M17,18 C15.9,18 15.01,18.9 15.01,20 C15.01,21.1 15.9,22 17,22 C18.1,22 19,21.1 19,20 C19,18.9 18.1,18 17,18 Z M8.1,13 L15.55,13 C16.3,13 16.96,12.59 17.3,11.97 L21.16,4.96 L19.42,4 L15.55,11 L8.53,11 L4.27,2 L1,2 L1,4 L3,4 L6.6,11.59 L5.25,14.03 C4.52,15.37 5.48,17 7,17 L19,17 L19,15 L7,15 L8.1,13 Z","fillRule":"nonzero","key":1}),React.createElement("polygon",{"className":"color","fill":"#ffffff","points":"11 9 13 9 13 6 16 6 16 4 13 4 13 1 11 1 11 4 8 4 8 6 11 6","key":2})]));
}

BasketInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = BasketInline;

BasketInline.default = BasketInline;
